import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './matiere-ecole.reducer';

export const MatiereEcoleDeleteDialog = (props: RouteComponentProps<{ ecoleid: string; id: string }>) => {
  const { ecoleid, id } = props.match.params;
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const matiereEntity = useAppSelector(state => state.matiereEcole.entity);
  const updateSuccess = useAppSelector(state => state.matiereEcole.updateSuccess);

  const handleClose = () => {
    props.history.push(`/matiere-ecole/${ecoleid}`);
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity({ id, ecoleId: ecoleid }));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="matiereDeleteDialogHeading">
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="korischoolApp.matiere.delete.question">
        <Translate contentKey="korischoolApp.matiere.delete.question" interpolate={{ id: matiereEntity.nom }}>
          Are you sure you want to delete this Matiere?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-matiere" data-cy="entityConfirmDeleteButton" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default MatiereEcoleDeleteDialog;
